'use client';

import { FadeIn } from '../../animation/FadeIn.jsx';
import { cn } from '../../../lib/utils.js';

/**
 * 3-up Statistik-Karten. item.highlight: 'positive' | 'negative'.
 */
export function StatsBlock({ background, eyebrow, headline, items = [] }) {
  return (
    <section className={cn('py-20 md:py-32', background)}>
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        {(eyebrow || headline) && (
          <FadeIn>
            <div className="max-w-2xl mx-auto text-center mb-12">
              {eyebrow && (
                <p className="text-accent-dark dark:text-accent font-semibold uppercase tracking-wider text-sm mb-2">
                  {eyebrow}
                </p>
              )}
              {headline && (
                <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-gray-900 dark:text-gray-100">
                  {headline}
                </h2>
              )}
            </div>
          </FadeIn>
        )}
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((stat, i) => (
            <FadeIn key={i} delay={i * 0.1}>
              <div
                className={cn(
                  'text-center p-6 rounded-lg',
                  stat.highlight === 'negative'
                    ? 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800'
                    : 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800'
                )}
              >
                <div
                  className={cn(
                    'font-heading font-bold text-4xl md:text-5xl mb-2',
                    stat.highlight === 'negative'
                      ? 'text-red-600 dark:text-red-400'
                      : 'text-green-600 dark:text-green-400'
                  )}
                >
                  {stat.value}
                </div>
                <div className="text-sm text-gray-700 dark:text-gray-300">{stat.label}</div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
